import { ComponentLoader } from '../../webana';

import { WebanaDiv } from './components/div';

export const components: { [key: string]: ComponentLoader } = {
  Div: async () => WebanaDiv,
  'google:Map': async () =>
    (await import('./components/google-map')).WebanaGoogleMap
};



// WEBPACK FOOTER //
// ./src/modules/webana/index.ts